function PixelSprite({ rows, palette, className }) {
  const height = rows.length;
  const width = rows[0].length;

  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} ${height}`}
      shapeRendering="crispEdges"
      aria-hidden="true"
    >
      {rows.flatMap((row, y) =>
        [...row].map((cell, x) =>
          cell === "." ? null : (
            <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={palette[cell]} />
          )
        )
      )}
    </svg>
  );
}

const GHOST = [
  "......oooo......",
  "....oo####oo....",
  "...o########o...",
  "..o##ew##ew##o..",
  "..o##########o..",
  "..opp######ppo..",
  "..o##########o..",
  "..o###ssss###o..",
  "..o##########o..",
  "..o##########o..",
  "..o##########o..",
  "..o##########o..",
  "..o##.##.##.##o.",
  "..o#..#..#..#o..",
  "...o..o..o..o...",
];

const SPIDER = [
  "#..............#",
  ".#............#.",
  "..#...####...#..",
  "...#.##ww##.#...",
  "....########....",
  "...##########...",
  "....########....",
  "...#.##..##.#...",
  "..#...####...#..",
  ".#............#.",
  "#..............#",
];

const PUMPKIN = [
  ".......g........",
  "......gg........",
  ".....gg.........",
  "..oooooooooooo..",
  ".odoooooooooood.",
  "oooooooooooooooo",
  "oo##oooooooo##oo",
  "oo##oooooooo##oo",
  "oooooooooooooooo",
  "oooooooooooooooo",
  "ooo###oooo###ooo",
  "oooo########oooo",
  ".odoooooooooood.",
  "..oooooooooooo..",
  "...oooooooooo...",
  "....oooooooo....",
];

function cornerWebPath() {
  const spokes = [0, 22, 45, 68, 90].map((degree) => (degree * Math.PI) / 180);
  const rings = [22, 44, 66, 90];
  let path = "M0.6 0.6H99M0.6 0.6V99";

  spokes.forEach((angle) => {
    if (angle < 0.05 || angle > Math.PI / 2 - 0.05) return;
    path += `M0.6 0.6L${(Math.cos(angle) * 97).toFixed(1)} ${(Math.sin(angle) * 97).toFixed(1)}`;
  });

  rings.forEach((radius) => {
    for (let i = 0; i < spokes.length - 1; i += 1) {
      const start = spokes[i];
      const end = spokes[i + 1];
      const mid = (start + end) / 2;
      const bulge = radius * 1.14;
      const x0 = Math.cos(start) * radius;
      const y0 = Math.sin(start) * radius;
      const x1 = Math.cos(end) * radius;
      const y1 = Math.sin(end) * radius;
      const cx = Math.cos(mid) * bulge;
      const cy = Math.sin(mid) * bulge;
      path += `M${x0.toFixed(1)} ${y0.toFixed(1)}Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x1.toFixed(1)} ${y1.toFixed(1)}`;
    }
  });

  return path;
}

const WEB_PATH = cornerWebPath();

const ghostPalette = {
  "#": "currentColor",
  o: "#3b2460",
  e: "#241833",
  w: "#ffffff",
  p: "#f9a8d4",
  s: "#241833",
};

export function PixelGhost({ className }) {
  return <PixelSprite className={className} rows={GHOST} palette={ghostPalette} />;
}

export function PixelSpider({ className }) {
  return (
    <PixelSprite className={className} rows={SPIDER} palette={{ "#": "currentColor", w: "#ffffff" }} />
  );
}

export function PixelWeb({ className }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path d={WEB_PATH} stroke="currentColor" strokeWidth="1.15" />
    </svg>
  );
}

export function PixelPumpkin({ className }) {
  return (
    <PixelSprite
      className={className}
      rows={PUMPKIN}
      palette={{
        o: "#f97316",
        d: "#c2410c",
        g: "#3f6212",
        "#": "#7c2d12",
      }}
    />
  );
}
